// Decisión de color del snackbar para POST /calidad/vouchers/enviar.
// El endpoint responde exito: 1 aunque ningún envío haya salido, así que el
// color se deriva del resumen real de resultados por cliente.
export function resumenSnackbarColor (resumen = {}) {
  const enviados = Number(resumen.enviados || 0)
  const fallidos = Number(resumen.fallidos || 0)

  if (enviados > 0) return fallidos > 0 ? 'warning' : 'success'
  if (fallidos > 0) return 'error'
  return 'warning'
}

// true solo cuando el backend registró un envío real para ese cliente.
// 'ya_enviado' no cuenta: no crea fila nueva y el último estado de la grilla
// puede seguir siendo distinto de 'enviado'.
export function clienteFueEnviado (results, clienteId) {
  if (!Array.isArray(results)) return false
  return results.some(result => (
    Number(result && result.EncuestaClienteID) === Number(clienteId) &&
    result.Estado === 'enviado'
  ))
}
